import Button from 'components/Button'
import RightArrowIcon from 'components/icons/RightArrowIcon'
import React, { Fragment, useState } from 'react'

import { useNavigate } from 'react-router'
import CancelDriveDrawer from '../CancelDriveDrawer'

import { FooterFlex } from 'modules/Drives/Components/DrivePage/ConfirmationDrawer/Partials/ConfirmDrawer/style.js'
import {
  ClickView,
  CountDiv,
  DriveTitle,
  InterviewDiv,
  RoleFlex,
  RoleInfoFlex,
  RolenameFlex,
  RounNameDiv,
  RoundInfoFlex,
  TitleDiv,
} from 'modules/Drives/ViewDrive/DriveDetails/style'
import { getZeroBeforeInt } from 'utils/getZeroBeforeInt'

const DriveDetail = ({ driveRolesMetrics, driveData }) => {
  const navigate = useNavigate()
  const [cancelDrawer, setCancelDrawer] = useState(false)

  const handleView = (data, stageValue = 'all_candidates') => {
    let stage = stageValue ? `?stage=${stageValue}` : ''
    navigate(`role/${stage}`)
  }

  return (
    <>
      {Array.isArray(driveRolesMetrics) &&
        driveRolesMetrics?.map((data, index) => (
          <>
            <RolenameFlex
              key={index + data?.roleName}
              centerVertically
              row
              spaceBetween
            >
              <>
                <DriveTitle>{data?.roleName}</DriveTitle>
                <FooterFlex right>
                  <Button.Primary
                    onClick={() => handleView(data)}
                    height="32px"
                    width="54px"
                    text="View"
                  />
                </FooterFlex>
              </>
            </RolenameFlex>

            <RoleInfoFlex row spaceBetween>
              <Fragment>
                <RoleFlex column>
                  <TitleDiv>Candidates</TitleDiv>
                  <CountDiv>{getZeroBeforeInt(data?.candidateCount)}</CountDiv>
                </RoleFlex>
                <RoleFlex column>
                  <TitleDiv>Active in pipeline</TitleDiv>
                  <CountDiv>
                    {getZeroBeforeInt(data?.activeInPipelineCount)}
                  </CountDiv>
                </RoleFlex>
                <RoleFlex column>
                  <TitleDiv>Rejected</TitleDiv>
                  <CountDiv>{getZeroBeforeInt(data?.rejectedCount)}</CountDiv>
                </RoleFlex>
                <RoleFlex column border>
                  <TitleDiv>On Hold</TitleDiv>
                  <CountDiv>{getZeroBeforeInt(data?.onHoldCount)}</CountDiv>
                </RoleFlex>
              </Fragment>
            </RoleInfoFlex>
            {data?.rounds?.length > 0 && (
              <InterviewDiv>
                {data?.rounds?.map((round, index) => {
                  return (
                    <RoundInfoFlex
                      centerVertically
                      row
                      spaceBetween
                      isboader={data?.rounds?.length - 1 === index}
                      key={index + round?.roundName}
                    >
                      <RounNameDiv>
                        Round {getZeroBeforeInt(index + 1)} - {round?.roundName}
                      </RounNameDiv>
                      <RounNameDiv>
                        {getZeroBeforeInt(round?.count)}
                      </RounNameDiv>
                      <ClickView
                        onClick={() => handleView(data, round?.roundName)}
                      >
                        <RightArrowIcon />
                      </ClickView>
                    </RoundInfoFlex>
                  )
                })}
              </InterviewDiv>
            )}
          </>
        ))}
      {cancelDrawer && (
        <CancelDriveDrawer
          cancelDrawer={cancelDrawer}
          setCancelDrawer={setCancelDrawer}
          driveData={driveData}
        />
      )}
    </>
  )
}

export default DriveDetail
